import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'

const VehicleDeviceManagementStages: Record<Environment, string> = {
  [Environment.local]: `https://api.sandbox-eu.vw-admt.cloud/internal/vehicle-os/vdm/api/v1/internal`,
  [Environment.test]: `http://localhost:${mockServerPort}/api/vehicle-device-management`,
  [Environment.development]:
    'https://s32g3goz0e.execute-api.eu-central-1.amazonaws.com/development/vdm/api/v1',
  [Environment.integration]:
    'https://s32g3goz0e.execute-api.eu-central-1.amazonaws.com/development/vdm/api/v1',
  [Environment.production]:
    'https://s32g3goz0e.execute-api.eu-central-1.amazonaws.com/development/vdm/api/v1',
}

const Host = VehicleDeviceManagementStages[ENV]

export const VehicleDeviceManagementAreaEndpoints = {
  Host,
  Base: `${Host}`,
  Vehicles: {
    List: `${Host}/vehicles`,
    Get: `${Host}/vehicle`,
    Infleet: `${Host}/vehicle/infleet`,
  },
  Onboarding: {
    ByVin: `${Host}/onboarding`,
  },
}
